import React from 'react';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import CommonIcon from '@/components/CommonIcon';
import UserActionCount from '@/components/UserActionCount/mIndex';
import DotLottie from '@/components/DotLottie';
import { IPCUserAction, useUserAction, USER_ACTION_TYPE, USER_ACTION_LOTTIE_URL } from './config';
import Styles from './index.module.scss';

const UserAction = ({
  tid,
  title,
  isLoggin = false,
  className = '',
  size = 'md',
  type,
  status,
  count,
  customCb = () => {},
  trackCb = () => {},
  onReportSlsData,
}: IPCUserAction) => {
  const { selected, cnt, showAnimation, handleUserAction, onComplete } = useUserAction({
    tid, title, isLoggin, status, count, customCb, trackCb, onReportSlsData
  });
  const t = useTranslations();

  return (
    <div className={cx(Styles.root, className, Styles[size])}>
      <CommonIcon
        className={cx(Styles.icon, Styles[type], { [Styles.noActive]: !selected, [Styles.hide]: showAnimation })}
        icon={!!selected ? `${type}-active` : type}
        onClick={() => handleUserAction(type)}
      />
      {showAnimation && (
        <DotLottie
          className={cx(Styles.dotLottie, {[Styles.show]: showAnimation})}
          autoplay
          loop={false}
          src={type === USER_ACTION_TYPE.PRAISE ? USER_ACTION_LOTTIE_URL.PRAISE : USER_ACTION_LOTTIE_URL.COLLECT}
          onComplete={onComplete}
        />
      )}
      <UserActionCount className={Styles.actionNum} count={cnt} />
    </div>
  );
};

export { USER_ACTION_TYPE };

export default UserAction;
